function parseLocalDate(s) {
  if (s instanceof Date) return new Date(s.getFullYear(), s.getMonth(), s.getDate());
  const parts = String(s).split('T')[0].split('-');
  return new Date(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2]));
}

export function formatDateISO(d) {
  const date = parseLocalDate(d);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getMonday(d) {
  const date = parseLocalDate(d);
  const day = date.getDay();
  const diff = date.getDate() - day + (day === 0 ? -6 : 1);
  date.setDate(diff);
  return formatDateISO(date);
}

export function addDays(dateStr, n) {
  const d = parseLocalDate(dateStr);
  d.setDate(d.getDate() + n);
  return formatDateISO(d);
}

export function getWeekDays(mondayStr) {
  return Array.from({ length: 7 }, (_, i) => addDays(mondayStr, i));
}

export function getWeekEnd(mondayStr) {
  return addDays(mondayStr, 6);
}

export function formatDayLabel(dateStr, lang) {
  const d = new Date(dateStr + 'T00:00:00');
  const locale = lang === 'spanish' ? 'es-MX' : 'en-US';
  return d.toLocaleDateString(locale, { weekday: 'short', month: 'short', day: 'numeric' });
}

export function formatWeekRange(mondayStr, lang) {
  const fridayStr = getWeekEnd(mondayStr);
  const d1 = new Date(mondayStr + 'T00:00:00');
  const d2 = new Date(fridayStr + 'T00:00:00');
  const locale = lang === 'spanish' ? 'es-MX' : 'en-US';
  const opts = { month: 'short', day: 'numeric' };
  const range = `${d1.toLocaleDateString(locale, opts)} – ${d2.toLocaleDateString(locale, opts)}`;
  if (d1.getFullYear() !== d2.getFullYear()) {
    return `${d1.toLocaleDateString(locale, { ...opts, year: 'numeric' })} – ${d2.toLocaleDateString(locale, { ...opts, year: 'numeric' })}`;
  }
  return `${range}, ${d1.getFullYear()}`;
}

export function getTodayISO() {
  return formatDateISO(new Date());
}

export const DAY_KEYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

export function getMonthDays(year, month) {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const days = [];
  for (let d = new Date(firstDay); d <= lastDay; d.setDate(d.getDate() + 1)) {
    days.push(formatDateISO(new Date(d)));
  }
  return days;
}

export function getWeeksInMonth(year, month) {
  const firstDay = new Date(year, month, 1);
  const lastDay = new Date(year, month + 1, 0);
  const weeks = [];
  let current = getMonday(formatDateISO(firstDay));
  while (current <= formatDateISO(lastDay) || weeks.length === 0) {
    weeks.push(current);
    current = addDays(current, 7);
    if (weeks.length > 6) break;
  }
  return weeks;
}

export function buildVacationDateSet(vacations) {
  const set = new Set();
  (vacations || []).filter(v => v.status === 'approved').forEach(v => {
    let d = v.start_date;
    while (d <= v.end_date) {
      set.add(d);
      d = addDays(d, 1);
    }
  });
  return set;
}
